webpackJsonp([1],{

/***/ "07PK":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios__ = __webpack_require__("mtWM");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_axios__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

// import componentHandler from 'exports-loader?componentHandler!material-design-lite/material'

/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'HelloWorld',
  data: function data() {
    return {
      msg: 'Welcome to Your Vue.js App',
      email: '',
      company: '',
      part: 'main'
    };
  },
  updated: function updated() {
    // this.$nextTick(() => {
    //   componentHandler.upgradeDom()
    // })
  },

  methods: {
    contact: function contact() {
      __WEBPACK_IMPORTED_MODULE_0_axios___default()({
        method: 'post',
        url: 'https://formspree.io/damien@pumpsoft.se',
        data: { email: this.email },
        headers: { 'X-Requested-With': 'XMLHttpRequest' }
      });
    },
    changePart: function changePart(part) {
      this.part = part;
    }
  }
});

/***/ }),

/***/ "0koP":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "0wRR":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/pageOne.231a0a7.png";

/***/ }),

/***/ "2Wt2":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/pageFour.6133038.png";

/***/ }),

/***/ "2cff":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/pageThree.b8fb822.png";

/***/ }),

/***/ "2mdq":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/iphoneSearch.8b3a511.png";

/***/ }),

/***/ "4YD0":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/table.2bd1522.png";

/***/ }),

/***/ "7Otq":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/logo.33b67d1.png";

/***/ }),

/***/ "M93x":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_App_vue__ = __webpack_require__("xJD8");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_4b60c1eb_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_App_vue__ = __webpack_require__("hBUb");
function injectStyle (ssrContext) {
  __webpack_require__("0koP")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
  var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_App_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_4b60c1eb_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_App_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "NHnr":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__("7+uW");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__App__ = __webpack_require__("M93x");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__router__ = __webpack_require__("YaEn");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_material_design_lite_material_min_css__ = __webpack_require__("kJoL");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_material_design_lite_material_min_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_material_design_lite_material_min_css__);
// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.




__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].config.productionTip = false;

/* eslint-disable no-new */
new __WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */]({
  el: '#app',
  router: __WEBPACK_IMPORTED_MODULE_2__router__["a" /* default */],
  template: '<App/>',
  components: { App: __WEBPACK_IMPORTED_MODULE_1__App__["a" /* default */] }
});

/***/ }),

/***/ "TOtK":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/pumpsoftwhite.10c927b.png";

/***/ }),

/***/ "WlH4":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "YaEn":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__("7+uW");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_router__ = __webpack_require__("/ocq");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_HelloWorld__ = __webpack_require__("gORT");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_HelloWorld2__ = __webpack_require__("mSgz");





__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_1_vue_router__["a" /* default */]);

/* harmony default export */ __webpack_exports__["a"] = (new __WEBPACK_IMPORTED_MODULE_1_vue_router__["a" /* default */]({
  routes: [{
    path: '/',
    name: 'Hello',
    component: __WEBPACK_IMPORTED_MODULE_2__components_HelloWorld__["a" /* default */]
  }, {
    path: '/abc/',
    name: 'Hello2',
    component: __WEBPACK_IMPORTED_MODULE_3__components_HelloWorld2__["a" /* default */]
  }]
}));

/***/ }),

/***/ "aDMt":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "cMV1":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'HelloWorld',
  data: function data() {
    return {
      msg: 'Welcome to Your Vue.js App'
    };
  }
});

/***/ }),

/***/ "eJoQ":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/searchShort.cfdd550.png";

/***/ }),

/***/ "eXop":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"hello2"},[_c('router-link',{attrs:{"to":"/"}},[_vm._v("sdasd")]),_vm._v(" "),_c('h1',[_vm._v(_vm._s(_vm.msg))]),_vm._v(" "),_c('h2',[_vm._v("Essential Links")]),_vm._v(" "),_vm._m(0),_vm._v(" "),_c('h2',[_vm._v("Ecosystem")]),_vm._v(" "),_vm._m(1)],1)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('ul',[_c('li',[_c('a',{attrs:{"href":"https://vuejs.org","target":"_blank"}},[_vm._v("Core Docs")])]),_vm._v(" "),_c('li',[_c('a',{attrs:{"href":"https://forum.vuejs.org","target":"_blank"}},[_vm._v("Forum")])]),_vm._v(" "),_c('li',[_c('a',{attrs:{"href":"https://chat.vuejs.org","target":"_blank"}},[_vm._v("Community Chat")])]),_vm._v(" "),_c('li',[_c('a',{attrs:{"href":"https://twitter.com/vuejs","target":"_blank"}},[_vm._v("Twitter")])]),_vm._v(" "),_c('br'),_vm._v(" "),_c('li',[_c('a',{attrs:{"href":"http://vuejs-templates.github.io/webpack/","target":"_blank"}},[_vm._v("Docs for This Template")])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('ul',[_c('li',[_c('a',{attrs:{"href":"http://router.vuejs.org/","target":"_blank"}},[_vm._v("vue-router")])]),_vm._v(" "),_c('li',[_c('a',{attrs:{"href":"http://vuex.vuejs.org/","target":"_blank"}},[_vm._v("vuex")])]),_vm._v(" "),_c('li',[_c('a',{attrs:{"href":"http://vue-loader.vuejs.org/","target":"_blank"}},[_vm._v("vue-loader")])]),_vm._v(" "),_c('li',[_c('a',{attrs:{"href":"https://github.com/vuejs/awesome-vue","target":"_blank"}},[_vm._v("awesome-vue")])])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "feQG":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/friction.fd79a32.png";

/***/ }),

/***/ "gORT":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_HelloWorld_vue__ = __webpack_require__("07PK");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_406b69ca_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_HelloWorld_vue__ = __webpack_require__("nSHo");
function injectStyle (ssrContext) {
  __webpack_require__("WlH4")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
  var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-406b69ca"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_HelloWorld_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_406b69ca_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_HelloWorld_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "gqQa":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/chart.da20658.png";

/***/ }),

/***/ "hBUb":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"app"}},[_c('router-view')],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "kJoL":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "l+i2":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/sewage.07ea872.png";

/***/ }),

/***/ "mSgz":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_HelloWorld2_vue__ = __webpack_require__("cMV1");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_4c8a6932_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_HelloWorld2_vue__ = __webpack_require__("eXop");
function injectStyle (ssrContext) {
  __webpack_require__("aDMt")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
  var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-4c8a6932"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_HelloWorld2_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_4c8a6932_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_HelloWorld2_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "nSHo":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticClass:"mdl-layout mdl-js-layout mdl-layout--fixed-header ",attrs:{"id":"Dashboard"}},[_c('div',{staticClass:"slopedBack"}),_vm._v(" "),_c('header',{staticClass:"mdl-layout__header mdl-layout__header--scroll "},[_c('div',{staticClass:"mdl-layout-icon"}),_vm._v(" "),_c('div',{staticClass:"mdl-layout__header-row "},[_c('img',{staticClass:"logo logoshift",attrs:{"id":"logoNav","src":__webpack_require__("7Otq"),"width":"200px"}}),_vm._v(" "),_c('nav',{staticClass:"mdl-navigation"},[_c('a',{staticClass:"pumpsoft mdl-navigation__link",attrs:{"href":"#pumpSelector"},on:{"click":function($event){_vm.changePart('main')}}},[_vm._v("Pump Selector")]),_vm._v(" "),_c('a',{staticClass:"pumpsoft mdl-navigation__link",attrs:{"href":"#dutyPoint"},on:{"click":function($event){_vm.changePart('friction')}}},[_vm._v("Duty Point Calculator")]),_vm._v(" "),_c('a',{staticClass:"pumpsoft mdl-navigation__link",attrs:{"href":"#sewage"},on:{"click":function($event){_vm.changePart('sewage')}}},[_vm._v("Sewage System Simulator")]),_vm._v(" "),_c('a',{staticClass:"pumpsoft mdl-navigation__link",attrs:{"href":"#instantOffer"},on:{"click":function($event){_vm.changePart('docs')}}},[_vm._v("Instant Offer")]),_vm._v(" "),_c('a',{staticClass:"pumpsoft mdl-navigation__link",attrs:{"href":"#insight"},on:{"click":function($event){_vm.changePart('insight')}}},[_vm._v("\n              Customer Insight")])])])]),_vm._v(" "),_c('div',{staticClass:"mdl-layout__drawer"},[_c('nav',{staticClass:"mdl-navigation"},[_c('a',{staticClass:"pumpsoft mdl-navigation__link",attrs:{"href":"#pumpSelector"},on:{"click":function($event){_vm.changePart('main')}}},[_vm._v("Pump Selector")]),_vm._v(" "),_c('a',{staticClass:"pumpsoft mdl-navigation__link",attrs:{"href":"#dutyPoint"},on:{"click":function($event){_vm.changePart('friction')}}},[_vm._v("Duty Point Calculator")]),_vm._v(" "),_c('a',{staticClass:"pumpsoft mdl-navigation__link",attrs:{"href":"#sewage"},on:{"click":function($event){_vm.changePart('sewage')}}},[_vm._v("Sewage System Simulator")]),_vm._v(" "),_c('a',{staticClass:"pumpsoft mdl-navigation__link",attrs:{"href":"#instantOffer"},on:{"click":function($event){_vm.changePart('docs')}}},[_vm._v("Instant Offer")]),_vm._v(" "),_c('a',{staticClass:"pumpsoft mdl-navigation__link",attrs:{"href":"#insight"},on:{"click":function($event){_vm.changePart('insight')}}},[_vm._v("\n              Customer Insight")])])]),_vm._v(" "),_c('main',{staticClass:"mdl-layout__content"},[_c('div',{staticClass:"page-content longScreen"},[_c('div',{staticClass:"mdl-grid"},[_c('div',{staticClass:"mdl-cell mdl-cell--10-col-desktop mdl-cell--1-offset-desktop mdl-cell--8-col-tablet mdl-cell--4-col-phone onePage firstPage"},[_c('div',{staticClass:"mdl-grid"},[_c('div',{staticClass:"mdl-cell  mdl-cell--8-col-tablet mdl-cell--6-col-desktop   mdl-cell--4-col-phone  titleDiv"},[_c('h2',[_vm._v("PumpSoft: Your Pumps, One Platform")]),_vm._v(" "),_c('h4',[_vm._v("PumpSoft saves time, automates sales and increases availability for pump distributors and manufacturers")]),_vm._v(" "),_c('div',{staticClass:"mdl-cell mdl-cell--8-col-tablet mdl-cell--12-col-desktop   mdl-cell--4-col-phone formCont "},[_c('form',{attrs:{"action":"https://formspree.io/damien@pumpsoft.se","method":"POST"}},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.email),expression:"email"}],staticClass:"textfield",attrs:{"type":"text","placeholder":" Enter your email...","name":"email"},domProps:{"value":(_vm.email)},on:{"input":function($event){if($event.target.composing){ return; }_vm.email=$event.target.value}}}),_vm._v(" "),_c('input',{staticClass:"mdl-button mdl-js-button  mdl-button--colored mdl-js-ripple-effect",attrs:{"type":"submit","value":"Contact Sales"}})])])]),_vm._v(" "),_vm._m(0)])]),_vm._v(" "),_vm._m(1),_vm._v(" "),_vm._m(2),_vm._v(" "),_vm._m(3),_vm._v(" "),_vm._m(4),_vm._v(" "),_vm._m(5),_vm._v(" "),_c('hr'),_vm._v(" "),_vm._m(6),_vm._v(" "),_c('div',{staticClass:"mdl-cell mdl-cell--6-col-desktop mdl-cell--3-offset-desktop mdl-cell--8-col-tablet mdl-cell--4-col-phone"},[_c('div',{staticClass:"mdl-grid"},[_c('div',{staticClass:"mdl-cell  mdl-cell--7-col-tablet mdl-cell--10-col-desktop  mdl-cell--1-offset-desktop mdl-cell--4-col-phone  "},[_c('form',{attrs:{"action":"https://formspree.io/damien@pumpsoft.se","method":"POST"}},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.email),expression:"email"}],staticClass:"textfield",attrs:{"type":"text","placeholder":"  Enter your email...","name":"email"},domProps:{"value":(_vm.email)},on:{"input":function($event){if($event.target.composing){ return; }_vm.email=$event.target.value}}}),_vm._v(" "),_c('input',{staticClass:"mdl-button mdl-js-button  mdl-button--colored mdl-js-ripple-effect",attrs:{"type":"submit","value":"Contact Sales"}})])])])])]),_vm._v(" "),_vm._m(7)])])])])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"mdl-cell  mdl-cell--8-col-tablet mdl-cell--6-col-desktop  mdl-cell--4-col-phone"},[_c('div',{staticClass:"mdl-grid"},[_c('div',{staticClass:"mdl-cell mdl-cell--2-col-desktop mdl-cell--2-col-tablet mdl-cell--1-col-phone"},[_c('img',{staticClass:"fullMock titleMock",attrs:{"id":"mock","src":__webpack_require__("eJoQ")}})]),_vm._v(" "),_c('div',{staticClass:"mdl-cell mdl-cell--5-col-desktop mdl-cell--2-offset-desktop mdl-cell--4-col-tablet mdl-cell--2-col-phone "},[_c('img',{staticClass:"fullMock titleMock",attrs:{"id":"mock","src":__webpack_require__("4YD0")}})]),_vm._v(" "),_c('div',{staticClass:"mdl-cell mdl-cell--3-col-desktop  mdl-cell--2-col-tablet mdl-cell--1-col-phone   "},[_c('img',{staticClass:"fullMock mockSide titleMock",attrs:{"id":"mock","src":__webpack_require__("gqQa")}})])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"mdl-cell mdl-cell--10-col-desktop mdl-cell--1-offset-desktop mdl-cell--8-col-tablet mdl-cell--4-col-phone onePage"},[_c('div',{staticClass:"slopedBack1"}),_vm._v(" "),_c('div',{staticClass:"mdl-grid "},[_c('div',{staticClass:"mdl-cell mdl-cell--6-col-desktop mdl-cell--8-col-tablet mdl-cell--4-col-phone   "},[_c('div',{staticClass:"mdl-grid "},[_c('div',{staticClass:"mdl-cell mdl-cell--12-col-desktop mdl-cell--8-col-tablet mdl-cell--4-col-phone   "},[_c('h1',{staticClass:"whiteText"},[_vm._v("Benefits")]),_vm._v(" "),_c('p',{staticClass:"whiteText"},[_vm._v("\n      PUMPSOFT is a subscription based pump selection software for pump importers and exporters. We digitalize our clients portfolios and create a customized search engine with detailed technical specifications for each pump.\n\n      ")]),_vm._v(" "),_c('p',{staticClass:"whiteText"},[_vm._v("\n      We do this by using machine learning to gather performance charts, drawings and technical specifications from multiple pump manufacturers on one platform.\n      ")]),_vm._v(" "),_c('p',{staticClass:"whiteText"},[_vm._v("\n\n      We make the \"your pumps, one platform\" concept a reality by connecting the software to our clients' inventory system, enabling the user to find the right pump faster than ever before.\n          ")]),_vm._v(" "),_c('p',{staticClass:"whiteText"})])])]),_vm._v(" "),_c('div',{staticClass:"mdl-cell mdl-cell--6-col-desktop mdl-cell--8-col-tablet mdl-cell--4-col-phone   "},[_c('div',{staticClass:"mdl-grid "},[_c('div',{staticClass:"mdl-cell mdl-cell--12-col-desktop mdl-cell--4-col-tablet mdl-cell--4-col-phone  benefits "},[_c('h3',{},[_vm._v("Save Time "),_c('i',{staticClass:"far fa-clock"})]),_vm._v(" "),_c('p',[_vm._v("\n    Faster and more convenient pump selection. For distributors this means sales reps working in one pump selector instead of multiple.\n        ")])]),_vm._v(" "),_c('div',{staticClass:"mdl-cell mdl-cell--12-col-desktop mdl-cell--4-col-tablet mdl-cell--4-col-phone benefits"},[_c('h3',{},[_vm._v("Automate Sales "),_c('i',{staticClass:"fas fa-shopping-cart"})]),_vm._v(" "),_c('p',[_vm._v("\n    Automate the sales process by enabling customers to serve themselves with pump selection.\n        ")])]),_vm._v(" "),_c('div',{staticClass:"mdl-cell mdl-cell--12-col-desktop mdl-cell--8-col-tablet mdl-cell--4-col-phone benefits "},[_c('h3',{},[_vm._v("Increased Availability "),_c('i',{staticClass:"fas fa-users"})]),_vm._v(" "),_c('p',[_vm._v("\n          Make it possible for your customers to serve themselves and rate pumps at anytime.\n        ")])])])])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"mdl-cell mdl-cell--10-col-desktop mdl-cell--1-offset-desktop mdl-cell--8-col-tablet mdl-cell--4-col-phone onePage "},[_c('div',{staticClass:"slopedBack2"}),_vm._v(" "),_c('a',{attrs:{"name":"pumpSelector"}}),_vm._v(" "),_c('div',{staticClass:"mdl-grid "},[_c('div',{staticClass:"mdl-cell mdl-cell--5-col-desktop mdl-cell--8-col-tablet mdl-cell--4-col-phone   mdl-cell--middle"},[_c('h1',{staticClass:"pumpSelectorTitle whiteText"},[_vm._v("Pump Selector")])]),_vm._v(" "),_c('div',{staticClass:"mdl-cell mdl-cell--7-col-desktop mdl-cell--8-col-tablet mdl-cell--4-col-phone  partDescription "},[_c('p',{staticClass:" partDescription whiteText"},[_vm._v("\n        Pumpsoft is focused on "),_c('strong',[_vm._v("speed")]),_vm._v(", simplicity and flexibility in order to create a frictionless user experience. The program rates the pumps based on duty point, while also providing  more simplified selection based on capacity and max pressure or through the built-in search engine. PUMPSOFT can be further customized to account for high viscosity fluids, abrasive particles, ATEX requirement, special elastomers etc., which makes PUMPSOFT adaptable for all types of centrifugal pump and applications.\n\n      ")])]),_vm._v(" "),_c('div',{staticClass:"mdl-cell mdl-cell--2-col-desktop mdl-cell--2-col-tablet mdl-cell--1-col-phone   "},[_c('img',{staticClass:"fullMock mockSide titleMock",attrs:{"id":"","src":__webpack_require__("eJoQ")}})]),_vm._v(" "),_c('div',{staticClass:"mdl-cell mdl-cell--7-col-desktop mdl-cell--3-col-tablet mdl-cell--2-col-phone   "},[_c('img',{staticClass:"fullMock titleMock",attrs:{"id":"","src":__webpack_require__("4YD0")}})]),_vm._v(" "),_c('div',{staticClass:"mdl-cell mdl-cell--3-col-desktop mdl-cell--2-col-tablet mdl-cell--1-col-phone   "},[_c('img',{staticClass:"fullMock mockSide titleMock",attrs:{"id":"","src":__webpack_require__("gqQa")}})])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"mdl-cell mdl-cell--10-col-desktop mdl-cell--1-offset-desktop mdl-cell--8-col-tablet mdl-cell--4-col-phone onePage"},[_c('div',{staticClass:"slopedBack3"}),_vm._v(" "),_c('a',{attrs:{"name":"dutyPoint"}}),_vm._v(" "),_c('div',{staticClass:"mdl-grid "},[_c('div',{staticClass:"mdl-cell mdl-cell--7-col-desktop mdl-cell--8-col-tablet mdl-cell--4-col-phone   "},[_c('h1',{staticClass:"pumpSelectorTitle whiteText"},[_vm._v("Duty Point Calculator")])]),_vm._v(" "),_c('div',{staticClass:"mdl-cell mdl-cell--5-col-desktop mdl-cell--8-col-tablet mdl-cell--4-col-phone   "},[_c('p',{staticClass:" partDescription whiteText"},[_vm._v("\n          Pumpsoft comes with an "),_c('strong',[_vm._v("intuitive")]),_vm._v(" Duty Point calculation tool that is completely integrated with the pump selector.\n        ")])]),_vm._v(" "),_c('div',{staticClass:"mdl-cell mdl-cell--12-col-desktop mdl-cell--8-col-tablet mdl-cell--4-col-phone   "},[_c('img',{staticClass:"fullMock",attrs:{"id":"friction","src":__webpack_require__("feQG"),"width":"100%"}})])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"mdl-cell mdl-cell--10-col-desktop mdl-cell--1-offset-desktop mdl-cell--8-col-tablet mdl-cell--4-col-phone onePage"},[_c('div',{staticClass:"slopedBack4"}),_vm._v(" "),_c('a',{attrs:{"name":"sewage"}}),_vm._v(" "),_c('div',{staticClass:"mdl-grid "},[_c('div',{staticClass:"mdl-cell mdl-cell--5-col-desktop mdl-cell--8-col-tablet mdl-cell--4-col-phone   "},[_c('h1',{staticClass:"pumpSelectorTitle whiteText"},[_vm._v("Simulator")])]),_vm._v(" "),_c('div',{staticClass:"mdl-cell mdl-cell--7-col-desktop mdl-cell--8-col-tablet mdl-cell--4-col-phone   "},[_c('p',{staticClass:" partDescription whiteText"},[_vm._v("\n          The Simulator is an add-on module that calculates duty points and rate pumps for more complex piping systems with multiple pumps operating simultaneously. This "),_c('strong',[_vm._v("saves time")]),_vm._v(" for sales reps and customers when rating pumps for larger projects.\n        ")])]),_vm._v(" "),_c('div',{staticClass:"mdl-cell mdl-cell--12-col-desktop mdl-cell--8-col-tablet mdl-cell--4-col-phone   "},[_c('img',{staticClass:"fullMock",attrs:{"id":"friction","src":__webpack_require__("l+i2"),"width":"100%"}})])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"mdl-cell mdl-cell--10-col-desktop mdl-cell--1-offset-desktop mdl-cell--8-col-tablet mdl-cell--4-col-phone onePage"},[_c('div',{staticClass:"slopedBack6"}),_vm._v(" "),_c('a',{attrs:{"name":"instantOffer"}}),_vm._v(" "),_c('div',{staticClass:"mdl-grid "},[_c('div',{staticClass:"mdl-cell mdl-cell--5-col-desktop mdl-cell--8-col-tablet mdl-cell--4-col-phone   "},[_c('h1',{staticClass:"pumpSelectorTitle whiteText"},[_vm._v("Instant Offer")])]),_vm._v(" "),_c('div',{staticClass:"mdl-cell mdl-cell--7-col-desktop mdl-cell--8-col-tablet mdl-cell--4-col-phone   "},[_c('p',{staticClass:" partDescription whiteText"},[_vm._v("\n          Instantly generates a technical specification sheet with your brand on it, containing user inputs, actual duty point, performance charts, technical specifications and drawings.\n        ")])]),_vm._v(" "),_c('div',{staticClass:"mdl-cell mdl-cell--3-col-desktop mdl-cell--2-col-tablet mdl-cell--1-col-phone   "},[_c('img',{staticClass:"fullMock ",attrs:{"id":"","src":__webpack_require__("0wRR")}})]),_vm._v(" "),_c('div',{staticClass:"mdl-cell mdl-cell--3-col-desktop mdl-cell--2-col-tablet mdl-cell--1-col-phone   "},[_c('img',{staticClass:"fullMock ",attrs:{"id":"","src":__webpack_require__("zIys")}})]),_vm._v(" "),_c('div',{staticClass:"mdl-cell mdl-cell--3-col-desktop mdl-cell--2-col-tablet mdl-cell--1-col-phone   "},[_c('img',{staticClass:"fullMock ",attrs:{"id":"","src":__webpack_require__("2cff")}})]),_vm._v(" "),_c('div',{staticClass:"mdl-cell mdl-cell--3-col-desktop mdl-cell--2-col-tablet mdl-cell--1-col-phone   "},[_c('img',{staticClass:"fullMock ",attrs:{"id":"","src":__webpack_require__("2Wt2")}})])]),_vm._v(" "),_c('a',{attrs:{"name":"insight"}}),_vm._v(" "),_c('div',{staticClass:"mdl-grid "},[_c('div',{staticClass:"mdl-cell mdl-cell--5-col-desktop mdl-cell--8-col-tablet mdl-cell--4-col-phone   "},[_c('h1',{staticClass:"pumpSelectorTitle whiteText"},[_vm._v("Customer Insight")])]),_vm._v(" "),_c('div',{staticClass:"mdl-cell mdl-cell--7-col-desktop mdl-cell--8-col-tablet mdl-cell--4-col-phone   "},[_c('p',{staticClass:" partDescription whiteText"},[_vm._v("\n        Enable sales reps to see what customers are searching for. This feature can be used by sales reps as an additional prospecting tool to generate "),_c('strong',[_vm._v("hot leads.")])])]),_vm._v(" "),_c('div',{staticClass:"mdl-cell mdl-cell--5-col-desktop mdl-cell--8-col-tablet mdl-cell--4-col-phone   "},[_c('h1',{staticClass:"pumpSelectorTitle whiteText"},[_vm._v("Mobile")])]),_vm._v(" "),_c('div',{staticClass:"mdl-cell mdl-cell--7-col-desktop mdl-cell--8-col-tablet mdl-cell--4-col-phone   "},[_c('p',{staticClass:" partDescription whiteText"},[_vm._v("\n          PUMPSOFT comes with a "),_c('strong',[_vm._v("mobile version.")]),_vm._v(" Generate a data sheet on the phone with your brand, containing user inputs, duty point, performance charts and technical specifications.\n\n        ")])]),_vm._v(" "),_c('div',{staticClass:"mdl-cell mdl-cell--12-col-desktop mdl-cell--8-col-tablet mdl-cell--4-col-phone   "},[_c('img',{staticClass:"mobile",attrs:{"id":"","src":__webpack_require__("2mdq"),"width":"50%"}})])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"mdl-cell mdl-cell--12-col-desktop  mdl-cell--8-col-tablet mdl-cell--4-col-phone freeQuote"},[_c('div',{staticClass:"slopedBack7"}),_vm._v("\n  Request a "),_c('strong',{staticClass:"free"},[_vm._v("free ")]),_vm._v("demo and quote\n")])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"mdl-cell mdl-cell--12-col-desktop mdl-cell--8-col-tablet mdl-cell--4-col-phone"},[_c('div',{staticClass:"mdl-grid"},[_c('div',{staticClass:"mdl-cell  mdl-cell--4-col-tablet mdl-cell--2-col-desktop  mdl-cell--4-col-phone"},[_c('img',{staticClass:"logo logoshift",attrs:{"id":"logoNav","src":__webpack_require__("TOtK"),"width":"200px"}})]),_vm._v(" "),_c('div',{staticClass:"mdl-layout-spacer"}),_vm._v(" "),_c('div',{staticClass:"mdl-cell  mdl-cell--4-col-tablet mdl-cell--6-col-desktop  mdl-cell--4-col-phone"},[_c('ul',[_c('li',[_c('i',{staticClass:"material-icons"},[_vm._v("")]),_c('a',{attrs:{"href":"#"}},[_vm._v("    robert@pumpsoft.se")])]),_vm._v(" "),_c('li',{staticClass:"footerDetails"},[_c('i',{staticClass:"material-icons"},[_vm._v("")]),_vm._v(" Lindstedtsvägen 24, floor 4 100 44 Stockholm")]),_vm._v(" "),_c('li',{staticClass:"footerDetails"},[_c('i',{staticClass:"material-icons"},[_vm._v("")]),_vm._v(" +46 764 664 018")])])])])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "xJD8":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'app'
});

/***/ }),

/***/ "zIys":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/pageTwo.65a22d2.png";

/***/ })

},["NHnr"]);


// WEBPACK FOOTER //
// static/js/app.1cc439bff13c30fedda5.js